export default __webpack_public_path__ + "f6dc41c2dfb6eb7c173cec34e845f09c.ttf";